var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:`icon ${_vm.size}`,style:({ fill: _vm.color })},[_c('use',{attrs:{"href":`${_vm.icons}#icon-${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }